import {EmployeeFeedback, EmployeeFeedbackJSON} from '../types/EmployeeFeedbackTypes';

export default class FeedbackSerializer {
  static toObject(payload: EmployeeFeedbackJSON): EmployeeFeedback {
    return payload.employee_feedback.map((feedback) => {
      return feedback;
    });
  }
}
